import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ErrorBoundary } from './ui/components/error/ErrorBoundary';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary
      onError={(error, errorInfo) => {
        console.error('[App] Error caught by ErrorBoundary:', error);
        console.error('[App] Error info:', errorInfo);
        
        if (import.meta.env.PROD) {
          console.error('[App] Production error - would send to error tracking service');
        }
      }}
    >
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);